var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreatorsLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.55556 3.33329H12.4444V8.66663H3.55556V3.33329ZM14.6667 5.99996C14.6667 6.73635 15.2636 7.33329 16 7.33329V9.99996C16 10.7363 15.4031 11.3333 14.6667 11.3333H1.33333C0.596944 11.3333 0 10.7363 0 9.99996V7.33329C0.736389 7.33329 1.33333 6.73635 1.33333 5.99996C1.33333 5.26357 0.736389 4.66663 0 4.66663V1.99996C0 1.26357 0.596944 0.666626 1.33333 0.666626H14.6667C15.4031 0.666626 16 1.26357 16 1.99996V4.66663C15.2636 4.66663 14.6667 5.26357 14.6667 5.99996ZM13.3333 3.11107C13.3333 2.74288 13.0349 2.4444 12.6667 2.4444H3.33333C2.96514 2.4444 2.66667 2.74288 2.66667 3.11107V8.88885C2.66667 9.25704 2.96514 9.55551 3.33333 9.55551H12.6667C13.0349 9.55551 13.3333 9.25704 13.3333 8.88885V3.11107Z",
    fill: "#DDE2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatorsLogo);
export default __webpack_public_path__ + "static/media/CreatorsLogo.b8624cbbb7e097e239213ece0f98fc25.svg";
export { ForwardRef as ReactComponent };